// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Thicker-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/obstcles.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: mediumThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.faq_wrapper {
  width: 100%;
  position: relative;
}

.faq_main_div {
  width: 100%;
  background-color: #fff !important;
}

.band_img_div_faq {
  width: 100%;
}

.band_img_div_faq > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* main text styling start here ----------------------------------------------- */

.faq_text_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq_text_div {
  width: 1443px;
  padding: 0 80px;
}

.faq_text_p1 {
  color: #ba1e24;
  font-family: lightThicker;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 126.6%;
  text-transform: uppercase;
  margin: 45px 0 16px 0;
}

.faq_text_p2 {
  color: #000;
  font-family: Thicker;
  font-size: 54px;
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.faq_text_p4 {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 16px 0 45px 0;
}

/* tabs sttling start here ----------------------------------------- */

.faq_tabs_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq_tabs_inner_div {
  width: 1443px;
  padding: 0 80px;
}

.faq_tabs_header {
  margin-top: 50px;
  padding-bottom: 13px;
  margin-bottom: 48px;
  border-bottom: 4px solid #d2d3d4;
}

.faq_tabs_header > a {
  text-decoration: none !important;
}

.faq_tab_active {
  color: #ba1e24;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-bottom: 4px solid #ba1e24;
  padding-bottom: 13px;
  margin-right: 75px;
  cursor: auto;
}

.faq_tab_inactive {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 13px;
  margin-right: 75px;
  cursor: pointer;
}

.faq_cards {
  width: 1045px;
}

.faq_card {
  border-bottom: 1px solid #d2d3d4;
}

.faq_card:last-child {
  border: none;
}

.faq_card_question_div {
  width: 100%;
  display: flex;
  align-items: center !important;
  justify-content: space-between;
  flex-direction: row;
  cursor: pointer;
  margin: 16px 0 16px 0;
}

.faq_card_question {
  color: #ba1e24;
  font-family: mediumThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0 !important;
}

.faq_card_answer_div {
  margin-bottom: 29px;
}

.faq_card_answer_div > a {
  color: #ba1e24 !important;
}

.faq_card_answer {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.faq_dont_find_p {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 30px 0 60px 0;
}

.faq_obstacles_div {
  width: 100%;
  height: 87px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media screen and (max-width: 1600px) {
  .faq_tabs_header {
    padding-bottom: 9px;
  }
}

@media screen and (max-width: 1200px) {
  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .faq_text_div {
    width: 100%;
    padding: 0 50px;
  }

  .faq_text_p1 {
    font-size: 24px;
    margin: 40px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 50px;
  }

  .faq_text_p4 {
    font-size: 20px;
    margin: 20px 0 20px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 50px;
  }

  .faq_tabs_header {
    padding-bottom: 9px;
    margin-bottom: 48px;
    border-bottom: 4px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 20px;
    border-bottom: 4px solid #ba1e24;
    padding-bottom: 13px;
    margin-right: 50px;
  }

  .faq_tab_inactive {
    font-size: 20px;
    padding-bottom: 13px;
    margin-right: 50px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 16px 0 16px 0;
  }

  .faq_card_question {
    font-size: 20px;
  }

  .faq_card_answer_div {
    margin-bottom: 29px;
  }

  .faq_card_answer {
    font-size: 18px;
  }

  .faq_dont_find_p {
    font-size: 20px;
    margin: 30px 0 60px 0;
  }

  .faq_obstacles_div {
    height: 87px;
  }
}

@media screen and (max-width: 1024px) {
  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .faq_text_div {
    width: 100%;
    padding: 0 40px;
  }

  .faq_text_p1 {
    font-size: 24px;
    margin: 60px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 50px;
    line-height: 56px;
  }

  .faq_text_p4 {
    font-size: 20px;
    line-height: 26px;
    margin: 20px 0 30px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 40px;
  }

  .faq_tabs_header {
    padding-bottom: 6px;
    margin-bottom: 48px;
    border-bottom: 3px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 20px;
    border-bottom: 3px solid #ba1e24;
    padding-bottom: 10px;
    margin-right: 50px;
  }

  .faq_tab_inactive {
    font-size: 20px;
    padding-bottom: 10px;
    margin-right: 50px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 12px 0 12px 0;
  }

  .faq_card_question {
    font-size: 20px;
  }

  .faq_card_answer_div {
    margin-bottom: 20px;
  }

  .faq_card_answer {
    font-size: 18px;
  }

  .faq_dont_find_p {
    font-size: 20px;
    margin: 30px 0 40px 0;
  }

  .faq_obstacles_div {
    height: 87px;
  }
}

@media screen and (max-width: 800px) {
  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .faq_text_div {
    width: 100%;
    padding: 0 30px;
  }

  .faq_text_p1 {
    font-size: 24px;
    margin: 60px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 46px;
    line-height: 54px;
  }

  .faq_text_p4 {
    font-size: 20px;
    line-height: 26px;
    margin: 20px 0 30px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 30px;
  }

  .faq_tabs_header {
    padding-bottom: 6px;
    margin-bottom: 30px;
    border-bottom: 3px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 18px;
    border-bottom: 3px solid #ba1e24;
    padding-bottom: 10px;
    margin-right: 40px;
  }

  .faq_tab_inactive {
    font-size: 18px;
    padding-bottom: 10px;
    margin-right: 40px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 12px 0 12px 0;
  }

  .faq_card_question {
    font-size: 18px;
  }

  .faq_card_answer_div {
    margin-bottom: 20px;
  }

  .faq_card_answer {
    font-size: 16px;
  }

  .faq_dont_find_p {
    font-size: 16px;
    margin: 30px 0 40px 0;
  }

  .faq_obstacles_div {
    height: 70px;
    background-repeat: repeat;
    background-position: center;
  }
}

@media screen and (max-width: 600px) {
  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .band_img_div_faq {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div_faq > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }
  .faq_text_div {
    width: 100%;
    padding: 0 20px;
  }

  .faq_text_p1 {
    font-size: 18px;
    margin: 60px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 30px;
    line-height: 36px;
  }

  .faq_text_p4 {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0 30px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 20px;
  }

  .faq_tabs_header {
    padding-bottom: 8px;
    margin-bottom: 30px;
    border-bottom: 3px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 18px;
    border-bottom: 3px solid #ba1e24;
    padding-bottom: 10px;
    margin-right: 40px;
  }

  .faq_tab_inactive {
    font-size: 18px;
    padding-bottom: 10px;
    margin-right: 40px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 10px 0 10px 0;
  }

  .faq_card_question {
    font-size: 18px;
    line-height: 22px;
    padding-right: 20px;
  }

  .faq_card_answer_div {
    margin-bottom: 15px;
  }

  .faq_card_answer {
    font-size: 16px;
    line-height: 20px;
  }

  .faq_dont_find_p {
    font-size: 16px;
    margin: 30px 0 40px 0;
  }

  .faq_obstacles_div {
    height: 70px;
  }
}

@media screen and (max-width: 450px) {
  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .faq_text_div {
    width: 100%;
    padding: 0 16px;
  }

  .faq_text_p1 {
    font-size: 18px;
    margin: 60px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 30px;
    line-height: 36px;
  }

  .faq_text_p4 {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0 30px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 16px;
  }

  .faq_tabs_header {
    padding-bottom: 8px;
    margin-bottom: 30px;
    border-bottom: 3px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 18px;
    border-bottom: 3px solid #ba1e24;
    padding-bottom: 10px;
    margin-right: 30px;
  }

  .faq_tab_inactive {
    font-size: 18px;
    padding-bottom: 10px;
    margin-right: 30px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card {
    padding: 6px 0;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 10px 0 10px 0;
  }

  .faq_card_question {
    font-size: 18px;
    line-height: 22px;
    padding-right: 20px;
  }

  .faq_card_answer_div {
    margin-bottom: 15px;
  }

  .faq_card_answer {
    font-size: 16px;
    line-height: 20px;
  }

  .faq_dont_find_p {
    font-size: 16px;
    margin: 30px 0 40px 0;
  }

  .faq_obstacles_div {
    height: 60px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}

@media screen and (max-width: 380px) {
  .faq_header_inner_div {
    width: 100%;
  }

  .faq_main_div {
    padding-top: 50px;
  }

  /* main text styling start here ----------------------------------------------- */

  .faq_text_main_div {
    max-width: 100%;
  }

  .faq_text_div {
    width: 100%;
    padding: 0 16px;
  }

  .faq_text_p1 {
    font-size: 18px;
    margin: 60px 0 6px 0;
  }

  .faq_text_p2 {
    font-size: 30px;
    line-height: 36px;
  }

  .faq_text_p4 {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0 30px 0;
  }

  /* tabs sttling start here ----------------------------------------- */

  .faq_tabs_div {
    max-width: 100%;
  }

  .faq_tabs_inner_div {
    width: 100%;
    padding: 0 16px;
  }

  .faq_tabs_header {
    padding-bottom: 9px;
    margin-bottom: 30px;
    border-bottom: 3px solid #d2d3d4;
  }

  .faq_tab_active {
    font-size: 18px;
    border-bottom: 3px solid #ba1e24;
    padding-bottom: 10px;
    margin-right: 30px;
  }

  .faq_tab_inactive {
    font-size: 18px;
    padding-bottom: 10px;
    margin-right: 30px;
  }

  .faq_cards {
    width: 100%;
  }

  .faq_card_question_div {
    justify-content: space-between;
    margin: 10px 0 10px 0;
  }

  .faq_card_question {
    font-size: 18px;
    line-height: 22px;
    padding-right: 20px;
  }

  .faq_card_answer_div {
    margin-bottom: 15px;
  }

  .faq_card_answer {
    font-size: 16px;
    line-height: 20px;
  }

  .faq_dont_find_p {
    font-size: 16px;
    margin: 30px 0 40px 0;
  }

  .faq_obstacles_div {
    height: 60px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/faq/faq.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,4CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iFAAiF;;AAEjF;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,sEAAsE;;AAEtE;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAkD;AACpD;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;EACD;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iFAAiF;;EAEjF;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,sEAAsE;;EAEtE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;EACxB;AACF","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n@font-face {\n  font-family: mediumThicker;\n  src: url(../../assets/fonts/Thicker-Medium.otf);\n}\n\n.faq_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.faq_main_div {\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.band_img_div_faq {\n  width: 100%;\n}\n\n.band_img_div_faq > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* main text styling start here ----------------------------------------------- */\n\n.faq_text_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.faq_text_div {\n  width: 1443px;\n  padding: 0 80px;\n}\n\n.faq_text_p1 {\n  color: #ba1e24;\n  font-family: lightThicker;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 126.6%;\n  text-transform: uppercase;\n  margin: 45px 0 16px 0;\n}\n\n.faq_text_p2 {\n  color: #000;\n  font-family: Thicker;\n  font-size: 54px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.faq_text_p4 {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin: 16px 0 45px 0;\n}\n\n/* tabs sttling start here ----------------------------------------- */\n\n.faq_tabs_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.faq_tabs_inner_div {\n  width: 1443px;\n  padding: 0 80px;\n}\n\n.faq_tabs_header {\n  margin-top: 50px;\n  padding-bottom: 13px;\n  margin-bottom: 48px;\n  border-bottom: 4px solid #d2d3d4;\n}\n\n.faq_tabs_header > a {\n  text-decoration: none !important;\n}\n\n.faq_tab_active {\n  color: #ba1e24;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border-bottom: 4px solid #ba1e24;\n  padding-bottom: 13px;\n  margin-right: 75px;\n  cursor: auto;\n}\n\n.faq_tab_inactive {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  padding-bottom: 13px;\n  margin-right: 75px;\n  cursor: pointer;\n}\n\n.faq_cards {\n  width: 1045px;\n}\n\n.faq_card {\n  border-bottom: 1px solid #d2d3d4;\n}\n\n.faq_card:last-child {\n  border: none;\n}\n\n.faq_card_question_div {\n  width: 100%;\n  display: flex;\n  align-items: center !important;\n  justify-content: space-between;\n  flex-direction: row;\n  cursor: pointer;\n  margin: 16px 0 16px 0;\n}\n\n.faq_card_question {\n  color: #ba1e24;\n  font-family: mediumThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  margin: 0 !important;\n}\n\n.faq_card_answer_div {\n  margin-bottom: 29px;\n}\n\n.faq_card_answer_div > a {\n  color: #ba1e24 !important;\n}\n\n.faq_card_answer {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.faq_dont_find_p {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin: 30px 0 60px 0;\n}\n\n.faq_obstacles_div {\n  width: 100%;\n  height: 87px;\n  background-image: url(\"../../assets/obstcles.png\");\n}\n\n@media screen and (max-width: 1600px) {\n  .faq_tabs_header {\n    padding-bottom: 9px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .faq_text_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .faq_text_p1 {\n    font-size: 24px;\n    margin: 40px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 50px;\n  }\n\n  .faq_text_p4 {\n    font-size: 20px;\n    margin: 20px 0 20px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 9px;\n    margin-bottom: 48px;\n    border-bottom: 4px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 20px;\n    border-bottom: 4px solid #ba1e24;\n    padding-bottom: 13px;\n    margin-right: 50px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 20px;\n    padding-bottom: 13px;\n    margin-right: 50px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 16px 0 16px 0;\n  }\n\n  .faq_card_question {\n    font-size: 20px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 29px;\n  }\n\n  .faq_card_answer {\n    font-size: 18px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 20px;\n    margin: 30px 0 60px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 87px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .faq_text_div {\n    width: 100%;\n    padding: 0 40px;\n  }\n\n  .faq_text_p1 {\n    font-size: 24px;\n    margin: 60px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 50px;\n    line-height: 56px;\n  }\n\n  .faq_text_p4 {\n    font-size: 20px;\n    line-height: 26px;\n    margin: 20px 0 30px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 40px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 6px;\n    margin-bottom: 48px;\n    border-bottom: 3px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 20px;\n    border-bottom: 3px solid #ba1e24;\n    padding-bottom: 10px;\n    margin-right: 50px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 20px;\n    padding-bottom: 10px;\n    margin-right: 50px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 12px 0 12px 0;\n  }\n\n  .faq_card_question {\n    font-size: 20px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 20px;\n  }\n\n  .faq_card_answer {\n    font-size: 18px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 20px;\n    margin: 30px 0 40px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 87px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .faq_text_div {\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .faq_text_p1 {\n    font-size: 24px;\n    margin: 60px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 46px;\n    line-height: 54px;\n  }\n\n  .faq_text_p4 {\n    font-size: 20px;\n    line-height: 26px;\n    margin: 20px 0 30px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 6px;\n    margin-bottom: 30px;\n    border-bottom: 3px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 18px;\n    border-bottom: 3px solid #ba1e24;\n    padding-bottom: 10px;\n    margin-right: 40px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 18px;\n    padding-bottom: 10px;\n    margin-right: 40px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 12px 0 12px 0;\n  }\n\n  .faq_card_question {\n    font-size: 18px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 20px;\n  }\n\n  .faq_card_answer {\n    font-size: 16px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 16px;\n    margin: 30px 0 40px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 70px;\n    background-repeat: repeat;\n    background-position: center;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .band_img_div_faq {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div_faq > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n  .faq_text_div {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .faq_text_p1 {\n    font-size: 18px;\n    margin: 60px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 30px;\n    line-height: 36px;\n  }\n\n  .faq_text_p4 {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0 30px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 8px;\n    margin-bottom: 30px;\n    border-bottom: 3px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 18px;\n    border-bottom: 3px solid #ba1e24;\n    padding-bottom: 10px;\n    margin-right: 40px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 18px;\n    padding-bottom: 10px;\n    margin-right: 40px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 10px 0 10px 0;\n  }\n\n  .faq_card_question {\n    font-size: 18px;\n    line-height: 22px;\n    padding-right: 20px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 15px;\n  }\n\n  .faq_card_answer {\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 16px;\n    margin: 30px 0 40px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 70px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .faq_text_div {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .faq_text_p1 {\n    font-size: 18px;\n    margin: 60px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 30px;\n    line-height: 36px;\n  }\n\n  .faq_text_p4 {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0 30px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 8px;\n    margin-bottom: 30px;\n    border-bottom: 3px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 18px;\n    border-bottom: 3px solid #ba1e24;\n    padding-bottom: 10px;\n    margin-right: 30px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 18px;\n    padding-bottom: 10px;\n    margin-right: 30px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card {\n    padding: 6px 0;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 10px 0 10px 0;\n  }\n\n  .faq_card_question {\n    font-size: 18px;\n    line-height: 22px;\n    padding-right: 20px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 15px;\n  }\n\n  .faq_card_answer {\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 16px;\n    margin: 30px 0 40px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 60px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .faq_header_inner_div {\n    width: 100%;\n  }\n\n  .faq_main_div {\n    padding-top: 50px;\n  }\n\n  /* main text styling start here ----------------------------------------------- */\n\n  .faq_text_main_div {\n    max-width: 100%;\n  }\n\n  .faq_text_div {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .faq_text_p1 {\n    font-size: 18px;\n    margin: 60px 0 6px 0;\n  }\n\n  .faq_text_p2 {\n    font-size: 30px;\n    line-height: 36px;\n  }\n\n  .faq_text_p4 {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0 30px 0;\n  }\n\n  /* tabs sttling start here ----------------------------------------- */\n\n  .faq_tabs_div {\n    max-width: 100%;\n  }\n\n  .faq_tabs_inner_div {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .faq_tabs_header {\n    padding-bottom: 9px;\n    margin-bottom: 30px;\n    border-bottom: 3px solid #d2d3d4;\n  }\n\n  .faq_tab_active {\n    font-size: 18px;\n    border-bottom: 3px solid #ba1e24;\n    padding-bottom: 10px;\n    margin-right: 30px;\n  }\n\n  .faq_tab_inactive {\n    font-size: 18px;\n    padding-bottom: 10px;\n    margin-right: 30px;\n  }\n\n  .faq_cards {\n    width: 100%;\n  }\n\n  .faq_card_question_div {\n    justify-content: space-between;\n    margin: 10px 0 10px 0;\n  }\n\n  .faq_card_question {\n    font-size: 18px;\n    line-height: 22px;\n    padding-right: 20px;\n  }\n\n  .faq_card_answer_div {\n    margin-bottom: 15px;\n  }\n\n  .faq_card_answer {\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .faq_dont_find_p {\n    font-size: 16px;\n    margin: 30px 0 40px 0;\n  }\n\n  .faq_obstacles_div {\n    height: 60px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
